import Reflux from 'reflux';

export default Reflux.createActions([
	'selectFilter',
	'selectAdditionalFilter',
	'search',
	'reset',
	'openFilter',
	'closeFilter',
]);
